<mat-form-field appearance="outline" class="flex-field full-width">
  <mat-select test-id="select"
    class="no-max-width"
    [ngClass]="{ 'hide-arrow': showClear && control.value?.length > 0 }"
    [panelClass]="showSearch ? 'search' : null"
    (selectionChange)="selectOption($event)"
    [formControl]="control"
    [matTooltip]="multiple ? getTooltipValue() : null"
    [multiple]="multiple"
    [placeholder]="placeholder"
    [required]="required">
    <mat-select-trigger *ngIf="selectAll">
      {{ getDisplayText() }}
    </mat-select-trigger>
    <div class="search-wrapper">
      <mat-form-field *ngIf="showSearch" appearance="outline" class="full-width no-min-width solid-background padding-5 flex-field">
        <mat-icon class="xs">search</mat-icon>
        <input matInput test-id="select-filter-input" [formControl]="search" [placeholder]="searchPlaceholder">
      </mat-form-field>
    </div>
    <ng-template #optionsList>
      <span *ngIf="selectAll" class="select-all" (click)="toggleSelectAll($event)">
        <mat-checkbox
          [indeterminate]="isIndeterminate"
          [checked]="allOptionsSelected"
          (click)="toggleSelectAll($event)">
        </mat-checkbox>
        <span [ngClass]="{ selected: allOptionsSelected }">
          Select All ({{options.length}})
        </span>
      </span>
      <mat-option (click)="$event.stopPropagation()"
        *ngFor="let option of options"
        [ngStyle]="{ display: filteredOptions.includes(option) ? 'flex' : 'none' }"
        [disabled]="option.disabled"
        [attr.test-id]="'app-select-option-' + option.label"
        [value]="option.value">
        {{ option.label || option.value }}
      </mat-option>
    </ng-template>
    <div *ngIf="showSearch" class="options-wrapper">
      <ng-container *ngTemplateOutlet="optionsList"></ng-container>
    </div>
    <ng-container *ngIf="!showSearch">
      <ng-container *ngTemplateOutlet="optionsList"></ng-container>
    </ng-container>
  </mat-select>
  <button mat-icon-button matSuffix test-id="clear"
    *ngIf="showClear && control.value?.length > 0"
    (click)="$event.stopPropagation(); clearValue()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error>{{ 'common.labels.fieldIsRequired' | translate }}</mat-error>
</mat-form-field>
